var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"util-menu-ul"},_vm._l((_vm.menuList),function(menu){return _c('li',{key:menu.name,class:_vm.menuClasses},[_c('a',{class:menu.classes,attrs:{"href":menu.url,"target":"_blank"}},[_vm._v(_vm._s(menu.name))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }